(function () {
  if (window.__ptGem) return; window.__ptGem = 1;
  var doc = null, wait = null;
  function emit(n, p) { try { if (window.traxEmit) window.traxEmit(n, p); } catch (e) {} }
  // the chip panels come from sections/pt-gemstone-panels.liquid on the first chip press, so the page carries none of them until then;
  // DOMParser keeps them inert (no picture loads) until one is placed in the page
  function load() {
    if (doc) return Promise.resolve(doc);
    if (wait) return wait;
    var pv = /[?&]preview_theme_id=(\d+)/.exec(location.search);
    wait = fetch(location.pathname + '?section_id=pt-gemstone-panels' + (pv ? '&preview_theme_id=' + pv[1] : ''), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (t) { doc = new DOMParser().parseFromString(t, 'text/html'); return doc; })
      .catch(function () { wait = null; return null; });
    return wait;
  }
  function shut(g) {
    if (!g) return;
    var p = g.querySelector('.pt-gp');
    if (p) p.hidden = true;
    var on = g.querySelectorAll('.pt-cp[aria-expanded="true"]');
    for (var i = 0; i < on.length; i++) on[i].setAttribute('aria-expanded', 'false');
  }
  function open(g, b) {
    var p = g.querySelector('.pt-gp'); if (!p) return;
    var r = p.querySelector('.pt-gpr'), w = b.getAttribute('data-w'), t = b.getAttribute('data-t') || '';
    p.querySelector('.pt-gpt').textContent = t;
    p.setAttribute('aria-label', t);
    r.textContent = '';
    p.hidden = false;
    b.setAttribute('aria-expanded', 'true');
    load().then(function (d) {
      if (b.getAttribute('aria-expanded') !== 'true') return;
      var s = d && d.querySelector('.pt-gpd[data-w="' + w + '"]');
      if (!s || !s.children.length) { shut(g); return; }
      r.textContent = '';
      for (var i = 0; i < s.children.length; i++) r.appendChild(document.importNode(s.children[i], true));
    });
  }
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.pt-cp[data-pt="chip"]')) load();
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pt]');
    if (!t) return;
    var g = t.closest('.pt-g'), c = g || t.closest('.pt-gu'), h = c ? c.getAttribute('data-ph') : '', k = t.getAttribute('data-pt');
    if (k === 'chip') {
      var was = t.getAttribute('aria-expanded') === 'true';
      shut(g);
      if (!was) {
        open(g, t);
        emit('select_promotion', { promotion_id: 'gemstone-chip', promotion_name: h + '|chip-' + t.getAttribute('data-w'), creative_slot: h, link_url: location.pathname });
      }
      return;
    }
    if (k === 'x') { shut(g); return; }
    var href = t.getAttribute('href') || '';
    emit('select_promotion', { promotion_id: 'gemstone-' + k, promotion_name: h + '|' + k + (k === 'tile' ? '-' + (t.getAttribute('data-i') || '') : ''),
      creative_slot: h, link_url: href || location.pathname });
  }, true);
  var b = document.querySelector('.pt-g');
  if (b && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) {
        var h = b.getAttribute('data-ph') || '';
        emit('view_promotion', { promotion_id: 'gemstone-view', promotion_name: h + '|row', creative_slot: h, link_url: location.pathname });
        io.disconnect(); break;
      }
    }, { threshold: 0.25 });
    io.observe(b);
  }
})();
